import { DetailsEditor } from "uikit"
import FaqLinks from "components/FaqLinks"
import React, { useEffect } from "react"
import { Redirect } from "react-router-dom"
import { useStore } from "store"
import { benefitTypes } from "../benefitTypes"
import { benefitWorksheets } from "./worksheetTypes"

const BenefitDetailsView = props => {
  useEffect(() => {
    window.trackEvent("edit-benefit", { type: props.type })
  }, [props.type])

  const { household, type, benefitId } = props
  const { worksheetType, accountOptionFilters } = benefitTypes[type]
  const [{ label, description, faqs = [] }] = useStore(
    "contextuals",
    `Benefit: ${type}`
  )
  const Worksheet = benefitWorksheets[worksheetType]

  const editor = benefit => {
    return (
      <DetailsEditor
        heading={`${benefitId === "new" ? "Add" : "Edit"} ${label}`}
        description={description}
        supplement={faqs.length >= 1 ? <FaqLinks items={faqs} /> : null}
      >
        <Worksheet
          household={household}
          accountOptionFilters={accountOptionFilters}
          success={<Redirect to="/organize/income+benefits" />}
          benefit={benefit}
          type={type}
        />
      </DetailsEditor>
    )
  }

  if (benefitId === "new") {
    return editor(null)
  }
  return <BenefitsDetailsEditor benefitId={benefitId} editor={editor} />
}

const BenefitsDetailsEditor = props => {
  const [benefit] = useStore("benefits", props.benefitId)
  return props.editor(benefit)
}

export default BenefitDetailsView
